import { createStore } from '@'

export const $modalVisible = createStore('modal:visible')
